import { Injectable } from '@angular/core';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { FirebaseService } from './firebase.service';

export interface BulenoxAccount {
  size: string;
  contracts: string;
}

export interface BulenoxOption {
  optionLabel: string;
  discount: string;
  couponCode: string;
  expiry: string;
  link: string;
  accounts: BulenoxAccount[];
}

export interface BulenoxAds {
  option1: BulenoxOption;
  option2: BulenoxOption;
}

const DEFAULTS: BulenoxAds = {
  option1: {
    optionLabel: 'Option 1 Accounts',
    discount: '89% OFF',
    couponCode: 'PROPDESK',
    expiry: '',
    link: 'https://bulenox.com/',
    accounts: [
      { size: '$25K',  contracts: '3 Contracts' },
      { size: '$50K',  contracts: '7 Contracts' },
      { size: '$100K', contracts: '12 Contracts' },
      { size: '$150K', contracts: '15 Contracts' },
    ],
  },
  option2: {
    optionLabel: 'Option 2 Accounts',
    discount: '45% OFF',
    couponCode: 'PROPDESK2',
    expiry: '',
    link: 'https://bulenox.com/',
    accounts: [
      { size: '$25K',  contracts: '3 Contracts' },
      { size: '$50K',  contracts: '7 Contracts' },
      { size: '$100K', contracts: '12 Contracts' },
      { size: '$150K', contracts: '15 Contracts' },
    ],
  },
};

@Injectable({ providedIn: 'root' })
export class SponsoredAdsService {
  private db: FirebaseService['db'];

  constructor(firebase: FirebaseService) {
    this.db = firebase.db;
  }

  async get(companyId = 'bulenox'): Promise<BulenoxAds> {
    try {
      const snap = await getDoc(doc(this.db, 'sponsoredAds', companyId));
      if (snap.exists()) return snap.data() as BulenoxAds;
    } catch { /* fall through to defaults */ }
    return DEFAULTS;
  }

  async save(data: BulenoxAds, companyId = 'bulenox'): Promise<void> {
    await setDoc(doc(this.db, 'sponsoredAds', companyId), data);
  }

  defaults(): BulenoxAds {
    return JSON.parse(JSON.stringify(DEFAULTS));
  }
}
